module.exports = __webpack_public_path__ + "static/img/header_bg.affd3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_bg.png
// module id = GZHf
// module chunks = 1